"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AnimatedChevron = _interopRequireDefault(require("./AnimatedChevron"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AnimatedIcons = {
  chevron: _AnimatedChevron["default"]
};
var _default = AnimatedIcons;
exports["default"] = _default;